import { useCallback } from 'react';
import { utils as commonUtils } from '@febos-io/common';
import { useDispatch } from 'react-redux';
import { utils as designUtils } from '@febos-io/design';
import useTranslation from '../useTranslation';
import { setLoading } from '../../store';

const { Auth } = commonUtils;

export default function useOnCompleteNewPasswordCallback(handleSignIn, response) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return useCallback(async ({ newPassword }, { setErrors, resetForm }) => {
    try {
      dispatch(setLoading(true));
      const user = await Auth.completeNewPassword(response.current, newPassword.trim());
      await handleSignIn(user);
      resetForm({
        email: '#',
        password: '#'
      });
    } catch (error) {
      dispatch(setLoading(false));
      setErrors({
        email: '#',
        password: '#'
      });

      designUtils.error(t('Something went wrong'));
    }
  }, [dispatch, handleSignIn, response, t]);
}
